import { Component, Input, OnInit } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { TitleService } from '@app/services/title.service';
import { WorkflowTimelineElement } from '@app/shared/components/feature-workflow-expand/feature-workflow-expand.component';

@Component({
  selector: 'app-tm-view-wf-row',
  templateUrl: './tm-view-wf-row.component.html',
  styleUrls: ['./tm-view-wf-row.component.scss']
})

export class TmViewWfRowComponent implements OnInit {

  /****************** Variable declaration ******************/
  /* Hover titles */
  expandIcon = this.titleService.expandIcon;
  collapseIcon = this.titleService.collapseIcon;

  panelOpened: boolean = false

  /****************** Input and Output decorators ******************/
  @Input() workflow: WorkflowTimelineElement;

  /**
   * Constructor
   * @param cf
   * @param titleService
   */
  constructor(
    private cf: CommonFunctionalitiesService,
    private titleService: TitleService
  ) { }

  /** ngOnInit */
  ngOnInit(): void { }

  /** changed panel opened */
  changepanelOpened() {
    this.panelOpened = !this.panelOpened
  }

  /** get class for dot */
  getClassForDot() {
    return this.workflow?.specificStatus === "success" ? "dot fit-width alert-success" : "dot fit-width alert-danger"
  }
}
